import React from 'react'

import MCEditorContext from 'components/MCTextEditor/MCEditorContext'
import { noLineBreaksMiddleware } from 'components/MCTextEditor/shared/middleware/noLineBreaks'
import { slicesEqual } from 'components/MCTextEditor/slice/slicesEqual'
import { createSmartLinkMiddlewares } from 'components/MCTextEditor/smartLinks/middleware'
import { createVariableMiddlewares } from 'components/MCTextEditor/variables/middleware'
import { createProcessorFabric } from 'components/RichTextEditor/processor/textProcessor'

interface UseProcessorFabricProps {
  noLineBreaks?: boolean
  withVariables?: boolean
  withSmartLinks?: boolean
}

export const useProcessorFabric = ({
  noLineBreaks = false,
  withVariables = false,
  withSmartLinks = false,
}: UseProcessorFabricProps = {}) => {
  const context = React.useContext(MCEditorContext)

  return createProcessorFabric(
    [
      ...(noLineBreaks ? [noLineBreaksMiddleware] : []),
      ...(withVariables ? createVariableMiddlewares(context.variables) : []),
      ...(withSmartLinks ? createSmartLinkMiddlewares(context.smartLinks) : []),
    ],
    slicesEqual,
  )
}
